import gql from 'graphql-tag'

export const AUTOCITE_CSL_DATA_FROM_DS = gql`
  query AutociteCslData($request: AutociteCslDataInput!) {
    autociteCslData(request: $request) {
      accessedPublication {
        day
        month
        year
      }
      authors {
        givenName
        lastName
      }
      containerTitle
      contentType
      contentTitle
      editors {
        givenName
        lastName
      }
      issuedPublication {
        day
        month
        year
      }
      publisherName
      translators {
        givenName
        lastName
      }
      url
    }
  }
`
